import { FC, useMemo } from 'react';

import { useSizeTypes } from 'contexts';
import { BookingDetails } from 'types';

import { useNewBooking } from './new-booking';

const NewReefer: FC = () => {
  const { booking, setBooking } = useNewBooking();
  const { isReefer } = useSizeTypes();

  const details: BookingDetails[] = useMemo(() => booking.bookingDetails ?? [], [booking.bookingDetails]);

  /* the catalog's reefer flag decides; the old regex missed 40RH and 45R1 */
  if (!details.some(({ iso }) => (iso ?? []).some(code => isReefer(code)))) return null;

  return (
    <div className="card-primary">
      <div className="card-header px-3">
        <h4>REEFER DETAILS</h4>
      </div>
      <div className="card-body">
        <div className="grid-5 p-2">
          <div>
            <h6 className="text-info-dark">BOOKING TEMP</h6>
            <div className="mt-2 position-relative">
              <input
                className="w-100"
                type="number"
                value={booking.bookingTemperature ?? ''}
                onChange={e =>
                  /* cleared means not specified; Number('') is 0, a false 0 °C the gate would fill from */
                  setBooking(b => ({ ...b, bookingTemperature: e.target.value === '' ? null : Number(e.target.value) }))
                }
              />
              <p className="end-adornment">°C</p>
            </div>
          </div>
          <div>
            <h6 className="text-info-dark">HUMIDITY</h6>
            <div className="mt-2 position-relative">
              <input
                className="w-100"
                type="number"
                value={booking.humidity ?? ''}
                onChange={e =>
                  setBooking(b => ({
                    ...b,
                    humidity: e.target.value === '' ? null : Math.max(0, Math.min(100, Number(e.target.value)))
                  }))
                }
              />
              <p className="end-adornment">%</p>
            </div>
          </div>
          <div>
            <h6 className="text-info-dark">VENTILATION</h6>
            <div className="mt-2 position-relative">
              <input
                className="w-100"
                type="string"
                value={booking.ventilation ?? ''}
                onChange={e =>
                  setBooking(b => ({ ...b, ventilation: e.target.value }))
                }
              />
              <p className="end-adornment">%</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewReefer;
